import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

import { fetchFromAPI } from "../utils/fetchFromAPI";
import { Videos, Sidebar ,Side,Loader} from "./";
import { Link } from "react-router-dom";

const Feed = ({setSelectedCategory}) => {
  // const [selectedCategory, setSelectedCategory] = useState("");
  const [videos, setVideos] = useState(null);
  const [shorts, setShorts] = useState(null);
  const [music, setMusics] = useState(null);
  const [sports, setSports] = useState(null);
  const { selectedCategory } = useParams();

  
  useEffect(() => {
    // console.log("good")
      setSelectedCategory("Home")
    
      fetchFromAPI(`search?relatedToVideoId=7ghhRHRP6t4&part=id`)
      .then((data) => setVideos(data.items))

      // fetchFromAPI(`search?part=snippet&q=Shorts`)
      // .then((data) => setShorts(data.items))

      fetchFromAPI(`search?part=snippet&q=MLS`)
      .then((data) => setSports(data.items))

      fetchFromAPI(`search?part=snippet&q=NCS`)
      .then((data) => setMusics(data.items))
    
    
    
    }, []);
    if(!videos?.length) return <Loader />;
  return (
    

      <Box p={2}  sx={{ overflowY: "auto", height: "90vh", flex: 2 }}>
        <Videos videos={videos.slice(0,8)} />

        <Typography variant="h4" fontWeight="bold"  mt={5} mb={2} sx={{ color: "white",mr: { sm: '100px' } }}>
          Great <span style={{ color: "#FC1503" }}>Music</span> Videos
        </Typography>
        {music&&<Videos videos={music.slice(0,22)} />}


        <Typography variant="h4" fontWeight="bold"  mt={5} mb={2} sx={{ color: "white",mr: { sm: '100px' } }}>
           Great <span style={{ color: "#FC1503" }}>Sports</span> Videos
        </Typography>
        {sports&&<Videos videos={sports.slice(0,23)} />}

        <Typography variant="h4" fontWeight="bold" mt={5}  mb={2} sx={{ color: "white",mr: { sm: '100px' } }}>
          Videos You May Like
        </Typography>
        {videos&&<Videos videos={videos.slice(9,51)} />}
      </Box>
    // </Stack>
  );
};

export default Feed;